import React, { useEffect, useState } from "react";
import DataTableBase from "../../../Components/Common/DataTableBase/DataTableBase";
import { t } from "i18next";
import { useSpacePopupStore } from "../../../stores/Assets/spacePopup";
import {
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import { useConfirmDialogStore } from "../../../stores/Modal/ConfirmDialogStore";
import { Permission } from "../../../Layouts/Permissions";
import { canEdit } from "../../../helpers/permissions";
import SearchBar from "../../../Components/Common/SearchBar";
import AddAnnouncement from "./Components/AddAnnouncement";
import EditAnnouncement from "./Components/EditAnnouncement";

const Announcements = () => {
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  document.title = "CLICKORDER | ANNOUNCEMENTS";
  const { getSpacePopups, isLoading, spacePopups, deleteSpacePopup, totalRows: storeTotalRows } =
    useSpacePopupStore((state) => state);


  const onPageChange = (page) => {

    getSpacePopups({ page: page, perPage: rowsPerPage, search: searchTerm });

    setCurrentPage(page);
  };


  useEffect(() => {
    setTotalRows(storeTotalRows || 0);
  }, [storeTotalRows]);

  const columns = [
    {
      name: t("ID"),
      width: "80px",
      selector: (row) => row?.id,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Site"),
      selector: (row) => row?.spaces[0]?.site?.name,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="d-flex flex-row justify-content-center align-items-center gap-2">
          <span>{row?.spaces[0]?.site?.name || "-"}</span>
        </div>
      ),
    },
    {
      name: t("Image"),
      width: "100px",
      selector: (row) => row.image,
      sortable: false,
      wrap: true,
      cell: (row) => (
        row?.image ? (
          <img
            src={row.image}
            style={{ borderRadius: "4px", maxWidth: "60px", maxHeight: "60px", objectFit: "cover" }}
            alt=""
          />
        ) : (
          <span className="text-muted">-</span>
        )
      ),
    },
    {
      name: t("Title"),
      selector: (row) => row?.title,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="d-flex flex-row justify-content-center align-items-center gap-2">
          <span>{row?.title || "-"}</span>
        </div>
      ),
    },
    {
      name: t("Title (AR)"),
      selector: (row) => row?.title_ar,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="d-flex flex-row justify-content-center align-items-center gap-2">
          <span>{row?.title_ar || "-"}</span>
        </div>
      ),
    },
    {
      name: t("Alias"),
      selector: (row) => row?.alias,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="d-flex flex-row justify-content-center align-items-center gap-2">
          <span>{row?.alias || "-"}</span>
        </div>
      ),
    },
    {
      name: t("Description"),
      selector: (row) => row?.description,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div style={{ maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis" }}>
          {row?.description || "-"}
        </div>
      ),
    },
    {
      name: t("Description (AR)"),
      selector: (row) => row?.description_ar,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div style={{ maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis" }}>
          {row?.description_ar || "-"}
        </div>
      ),
    },
    {
      name: t("Views"),
      selector: (row) => row?.views || 0,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <span className="badge bg-info">{row?.views || 0}</span>
      ),
    },
    {
      name: t("Starts At"),
      selector: (row) => row?.starts_at,
      sortable: true,
      wrap: true,
      cell: (row) => {
        if (!row?.starts_at) return <span className="text-muted">-</span>;
        const date = new Date(row.starts_at);
        return (
          <span>
            {date.toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              timeZoneName: "short",
            })}
          </span>
        );
      },
    },
    {
      name: t("Expires At"),
      selector: (row) => row?.expires_at,
      sortable: true,
      wrap: true,
      cell: (row) => {
        if (!row?.expires_at) return <span className="text-muted">-</span>;
        const date = new Date(row.expires_at);
        return (
          <span>
            {date.toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              timeZoneName: "short",
            })}
          </span>
        );
      },
    },
    {
      name: t("See Once"),
      selector: (row) => row?.see_once,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <span
          className={`badge ${row?.see_once ? "bg-success" : "bg-secondary"}`}
        >
          {row?.see_once ? "Yes" : "No"}
        </span>
      ),
    },
  ];

  const searchHandler = (searchText) => {
    setSearchTerm(searchText);
    setCurrentPage(1);
  };

  useEffect(() => {
    getSpacePopups({ page: 1, perPage: rowsPerPage, search: searchTerm });
  }, [searchTerm]);
  const { showConfirm } = useConfirmDialogStore((state) => state);

  const deleteSpacePopupFun = async (id) => {
    try {
      await deleteSpacePopup(id);
    } catch (e) {
      console.log(e);
    }
  };

  const [canEditAnnouncement, setCanEditAnnouncement] = useState(false);
  const [showAddAnnouncementModal, setShowAddAnnouncementModal] = useState(false);
  const [showEditAnnouncementModal, setShowEditAnnouncementModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const toggleAddAnnouncementModal = () => {
    setShowAddAnnouncementModal(!showAddAnnouncementModal);
  };

  const toggleEditAnnouncementModal = (row = null) => {
    if (row) {
      setSelectedRow(row);
    }
    setShowEditAnnouncementModal(!showEditAnnouncementModal);
    if (!showEditAnnouncementModal && !row) {
      setSelectedRow(null);
    }
  };

  useEffect(() => {
    const checkPermission = async () => {
      const res = await canEdit("space");
      setCanEditAnnouncement(res);
    };

    checkPermission();
  }, []);

  return (
    <>
      <DataTableBase
        tableTitle={"ANNOUNCEMENTS"}
        customHeader={
          <div className="d-flex flex-column flex-md-row align-items-stretch justify-content-between gap-2 w-100 mb-2">
            {canEditAnnouncement ? (
              <Permission level={2} feature="space">
                <Button
                  color="success"
                  onClick={toggleAddAnnouncementModal}
                  className="d-flex align-items-center justify-content-center w-100"
                  style={{
                    flex: "0 0 10%",
                    padding: "0.4rem 2rem",
                    whiteSpace: "nowrap",
                    fontSize: "13px",
                  }}
                >
                  + {t("Add Announcement")}
                </Button>
              </Permission>
            ) : null}
            <div
              className="d-flex align-items-center gap-2 w-100"
              style={{ flex: "0 0 40%" }}
            >
              <h6 className="text-nowrap mb-0">Search: </h6>
              <div className="flex-grow-1">
                <SearchBar
                  onSearch={searchHandler}
                  placeholder="Search announcements by title, description, or id..."
                />
              </div>
            </div>
          </div>
        }
        data={spacePopups}
        columns={columns}
        loading={isLoading}
        paginationTotalRows={totalRows}
        onChangePage={onPageChange}
        onHeaderAddBtnClick={null}
        onSearchIconClick={searchHandler}
        actionColWidth="100px"
        showSearch={false}
        showActionColumn={canEditAnnouncement}
        showSubHeader={false}
        showActionButtons={false}
        customActionBtns={(row) => (
          <>
            <Permission level={2} feature="space">
              <button
                className="btn btn-sm btn-warning"
                onClick={() => toggleEditAnnouncementModal(row)}
                title="Edit"
              >
                <i className="ri-edit-fill"></i>
              </button>
            </Permission>
            <Permission level={2} feature="space">
              <button
                className="btn btn-sm btn-danger"
                onClick={() => {
                  showConfirm(
                    () => {
                      deleteSpacePopupFun(row.id);
                    },
                    () => {
                      console.log("Cancelled");
                    },
                    t("Confirm Delete"),
                    `Are you sure you want to delete announcement ${row?.title || row?.id} (id: ${row?.id})?`
                  );
                }}
                title="Delete"
              >
                <i className="ri-delete-bin-line"></i>
              </button>
            </Permission>
          </>
        )}
      />

      <AddAnnouncement
        showAddAnnouncementModal={showAddAnnouncementModal}
        toggleAddAnnouncementModal={toggleAddAnnouncementModal}
      />

      {selectedRow && (
        <EditAnnouncement
          rowData={selectedRow}
          showEditAnnouncementModal={showEditAnnouncementModal}
          toggleEditAnnouncementModal={toggleEditAnnouncementModal}
        />
      )}
    </>
  );
};

export default Announcements;